import {PermissionEnum} from "../../../../utils/enums/permission-enum.js";

export const getDashboardPermissions = hasPermission => ({
    module: hasPermission(PermissionEnum.DISPATCH),
    myGarrison: hasPermission(PermissionEnum.MY_GARRISON) || hasPermission(PermissionEnum.MYGARRISON),
    attendanceSchedule: hasPermission(PermissionEnum.ATTENDANCE_SCHEDULE),
    attendance: hasPermission(PermissionEnum.ATTENDANCE_WEB),
    attendanceVisualization: hasPermission(PermissionEnum.ATTENDANCE_VISUALIZATION),
    garrison: hasPermission(PermissionEnum.GARRISON_WEB),
    appAllowViewCall: hasPermission(PermissionEnum.ATTENDANCE_APP_ALLOW_VIEW_CALL),
    retroactive: hasPermission(PermissionEnum.RETROACTIVE),
    garrisonSchedule: hasPermission(PermissionEnum.GARRISON_SCHEDULE),
    dispatch: hasPermission(PermissionEnum.DISPATCH_DISPATCH),
    task: hasPermission(PermissionEnum.DISPATCH_TASK_WEB),
    configuration: hasPermission(PermissionEnum.DISPATCH_ADMIN),
    activity: hasPermission(PermissionEnum.DISPATCH_ACTIVITY),
    activitySubordinates: hasPermission(PermissionEnum.DISPATCH_ACTIVITY_SUBORDINATES),
    contingent: hasPermission(PermissionEnum.CONTINGENT),
    leader: hasPermission(PermissionEnum.GARRISON_LEADER),
    gis: hasPermission(PermissionEnum.GIS),
});
